import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

/**
 * Refactored Wallet Store - Only UI state management
 * Data is handled by vue-query in queries/useWallet.ts
 */
export const useWalletStore = defineStore('wallet', () => {
  // UI State only - no data duplication
  const showWalletModal = ref(false)
  const showConfirmModal = ref(false)
  const pendingAddressConfirmation = ref('')

  // Computed properties for UI logic
  const hasWalletModal = computed(() => showWalletModal.value)
  const hasConfirmModal = computed(() => showConfirmModal.value)

  // UI Actions only
  function openWalletModal() {
    showWalletModal.value = true
  }

  function closeWalletModal() {
    showWalletModal.value = false
  }

  function openConfirmModal(address: string) {
    // Convert any input to string for graceful handling
    pendingAddressConfirmation.value = String(address)
    showConfirmModal.value = true
  }

  function closeConfirmModal() {
    showConfirmModal.value = false
    pendingAddressConfirmation.value = ''
  }

  function resetState() {
    showWalletModal.value = false
    showConfirmModal.value = false
    pendingAddressConfirmation.value = ''
  }

  return {
    // State
    showWalletModal,
    showConfirmModal,
    pendingAddressConfirmation,

    // Computed
    hasWalletModal,
    hasConfirmModal,

    // Actions
    openWalletModal,
    closeWalletModal,
    openConfirmModal,
    closeConfirmModal,
    resetState
  }
})
